module.exports = __webpack_public_path__ + "static/media/icon_removeDoc.0127002e.svg";